'use es6';

import Content from '../models/Content';
import { fromJS } from 'immutable';
import { RECEIVED_CONTENT, REQUESTED_CONTENT, REQUESTED_CONTENT_FAILED, REQUESTED_UPDATE_CONTENT, REQUESTED_UPDATE_CONTENT_FAILED } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new Content(), action) => {
  switch (action.type) {
    case REQUESTED_CONTENT:
    case REQUESTED_UPDATE_CONTENT:
      return state.set('status', RequestStatus.PENDING);
    case RECEIVED_CONTENT:
      return action.payload.content;
    case REQUESTED_CONTENT_FAILED:
    case REQUESTED_UPDATE_CONTENT_FAILED:
      {
        const {
          error = {}
        } = action.payload;
        return state.merge({
          error: fromJS({
            responseJSON: error.responseJSON,
            status: error.status
          }),
          status: RequestStatus.FAILED
        });
      }
    default:
      return state;
  }
});